import React from "react";
import { Link } from "react-router-dom";
import "./BlogCard.css";

const BlogCard = ({ blog }) => {
  const truncateText = (text, limit = 120) => {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    return new Date(dateStr).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    // A real <Link> (not onClick+navigate) so crawlers can discover and
    // index individual post URLs from the blog list page.
    <Link to={`/blog/${blog.slug}`} className="blog-card">
      <img
        src={blog.coverImage || "/images/avatar3.jpg"}
        alt={blog.title}
        width={400}
        height={220}
        loading="lazy"
      />

      <div className="blog-card-body">
        {/* DATE + READING TIME */}
        <div className="blog-meta">
          <span className="blog-date">{formatDate(blog.date)}</span>
          <span className="meta-dot"></span>
          <span className="blog-time">{blog.readingTime}</span>
        </div>

        {/* TITLE */}
        <h3>{blog.title}</h3>

        {/* PREVIEW TEXT */}
        <p className="blog-text">{truncateText(blog.preview)}</p>

        {/* CATEGORY + BUTTON */}
        <div className="blog-footer">
          <span className="blog-category">{blog.category}</span>
          <span className="explore-btn">Explore More →</span>
        </div>
      </div>
    </Link>
  );
};

export default BlogCard;
